module.exports = __webpack_public_path__ + "img/10_15.08cd43a0.png";